import axios from "axios";
export const DASHBOARD_DATA = `/api/v1/customer/dashboard`;
export const CAMPAIGN_DATA = `/api/v1/customer/campaign-details`;
export const NSU_CASHBACK = `/api/v1/customer/nsu-cashback-details`;
export const CUSTOMER_EMAILS = `/api/v1/customer/linked-email`;
export const SENT_OTP = `/api/v1/customer/send-otp-email`;
export const VERIFY_OTP = `/api/v1/customer/verify-otp-email`;

export function getDashboardData() {
  return axios.get(DASHBOARD_DATA, {
    validateStatus(status) {
      return true;
    },
  });
}
export function getCampaignDetails(orderUrl) {
  return axios.get(CAMPAIGN_DATA, {
    params: { orderUrl },
    validateStatus: (status) => true,
  });
}
export function getNsuCashbackDetails() {
  return axios.get(NSU_CASHBACK, {
    validateStatus(status) {
      return true;
    },
  });
}

export const getRestaurantPageData = (restaurantPrefix) => {
  return axios.get(`/api/v1/user/restaurant-page/${restaurantPrefix}`, {
    validateStatus(status) {
      return true;
    },
  });
};

export const getAllEmails = () => {
  return axios.get(CUSTOMER_EMAILS, {
    validateStatus(status) {
      return true;
    },
  });
};

export function sendOtp(selectedValue) {
  return axios.post(
    SENT_OTP,
    { email: selectedValue },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}

export function verifyOtp(otp) {
  return axios.post(
    VERIFY_OTP,
    { otp },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}
